import { system } from "./globals.mjs";
import { locationStartPagesSettings } from "./globals_common.mjs";

export function isLocationStartPageActive(locationStartPage) {
    return (system === "development") ||
            (system === "staging" && locationStartPagesSettings[locationStartPage].staging === true) ||
            (system === "production" && locationStartPagesSettings[locationStartPage].production === true);
}
